<template>
  <drop-down tag="li" class="nav-item">
    <a slot="title" class="nav-link user-profile-dropdown" data-toggle="dropdown" href="javascript:void(0)">
      <div class="user-avatar-wrapper">
        <b-icon icon="person-circle" class="user-icon"></b-icon>
      </div>
      <span class="username-text">{{ username }}</span>
      <b-icon style="color: rgb(107, 107, 107);" icon="chevron-down" font-scale="0.8" class="ml-1"></b-icon>
    </a>

    <ul class="dropdown-menu dropdown-menu-right custom-dropdown-menu">
      <li>
        <router-link :to="{ path: '/login' }" class="dropdown-item logout-link">
          <b-icon icon="box-arrow-right" class="mr-2"></b-icon>
          {{ $t("Chiqish") }}
        </router-link>
      </li>
    </ul>
  </drop-down>
</template>

<style scoped>
.user-profile-dropdown {
  display: flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 13px;
  border: 1px solid rgb(107, 107, 107);
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.03);
  /* Engil fon */
  text-decoration: none !important;
  height: 35px;
}

.user-profile-dropdown:hover {
  background: rgba(0, 0, 0, 0.08);
}

.user-avatar-wrapper {
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e72e4;
  /* Ikonka rangi */
}

.user-icon {
  font-size: 1.4rem;
}

.username-text {
  font-weight: 600;
  color: #32325d;
  font-size: 0.9rem;
}

/* Dropdown Menu dizayni */
.custom-dropdown-menu {
  border: none;
  box-shadow: 0 40px 80px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  padding: 10px 0;
  min-width: 180px;
}

.dropdown-item {
  padding: 5px 5px;
  display: flex;
  align-items: center;
  color: #525f7f;
  transition: background 0.2s;
}

.logout-link:hover {
  background-color: #fef1f1;
  /* Chiqish uchun engil qizil fon */
  color: #f5365c;
}
</style>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      exportfolder: "",
    };
  },
  computed: {
    username() {
      return localStorage.getItem('username');
    }
  },
  methods: {
    computeLocaleText(locale) {
      return this.$t(locale);
    }
  }
};
</script>

